import dayjs from 'dayjs';
import ShelfController from '../../../core/shelf.controller';
import { User } from '../../../data';
import { getContractType } from '../../../utils/contractTypes';
import { getTotalInvestment } from '../../../utils/tradeInvestment';
import { countStoresByChannel, filterChecksByStores, filterEntityByChannel } from '../../../utils/storeChannel';

class ContractController extends ShelfController {
    async initialize() {
        let contract = null;
        let contractChecks = null;

        if (this.isAuthenticated) {
            contract = await this.data.fetchContractById(this.props.searchParams.get('id'));
            const storeChecks = await this.data.fetchStoreCheckByContractId(this.props.searchParams.get('id'));
            contractChecks = await this.filterContractChecks(storeChecks);
        } else this.navigateLogin();

        this.setState({ contract, contractChecks, loading: false });
    }

    /** Guarda el precio de un piso puntual y refresca la contratación en pantalla. */
    async updateStorePrice(storeId, price) {
        try {
            const contractId = this.props.searchParams.get('id');
            const contract = await this.data.updateContractStorePrice(contractId, storeId, price);
            if (contract?._id) this.setState({ contract });
        } catch (err) {
            console.log(err);
        }
    }

    async filterContractChecks(storeChecks) {
        let checks = [];
        storeChecks?.forEach((storeCheck) => {
            const contractData = storeCheck?.contracts?.find((contract) => contract?.tradeContractId === this.props.searchParams.get('id'));
            if (contractData) {
                checks.push({
                    ...contractData,
                    storeId: storeCheck?.storeId,
                    createdAt: storeCheck?.createdAt,
                    updatedAt: storeCheck?.updatedAt
                });
            }
        });
        return checks;
    }

    handleChannelChange(channel) {
        this.setState({ channel });
    }

    /** Contratación y visitas recortadas al canal seleccionado. */
    getFilteredData() {
        const { contract, contractChecks, channel } = this.state;
        const filteredContract = filterEntityByChannel(contract, channel);
        const filteredChecks = filterChecksByStores(contractChecks, filteredContract?.stores);
        return { filteredContract, filteredChecks };
    }

    handleEdit() {
        const contractId = this.props.searchParams.get('id');
        this.props.navigate(`/dashboard/trade/contracts?edit=${contractId}`);
    }

    calculateAnalytics({ contract, contractChecks }) {
        if (!contract || !contractChecks) {
            return {
                totalStores: 0,
                uniqueStoresVisited: 0,
                totalVisits: 0,
                availableCount: 0,
                notAvailableCount: 0,
                complianceRate: 0,
                totalImages: 0,
                pendingImages: 0
            };
        }

        const totalStores = contract.stores?.length || 0;

        const uniqueStoreIds = new Set();
        contractChecks?.forEach((check) => {
            if (check.storeId) {
                uniqueStoreIds.add(check.storeId);
            }
        });
        const uniqueStoresVisited = uniqueStoreIds.size;

        const totalVisits = contractChecks?.length || 0;

        const availableVisitsCount = contractChecks?.filter((c) => c.available)?.length || 0;

        const storeLatestCheck = new Map();
        contractChecks?.forEach((check) => {
            const existingCheck = storeLatestCheck.get(check.storeId);
            if (!existingCheck || new Date(check.createdAt) > new Date(existingCheck.createdAt)) {
                storeLatestCheck.set(check.storeId, check);
            }
        });

        const availableCount = Array.from(storeLatestCheck.values()).filter((c) => c.available).length;
        const notAvailableCount = uniqueStoresVisited - availableCount;
        const complianceRate = uniqueStoresVisited > 0 ? (availableCount / uniqueStoresVisited) * 100 : 0;

        let totalImages = 0;
        let pendingImages = 0;

        contractChecks?.forEach((check) => {
            if (check.images?.length) {
                check.images.forEach((img) => {
                    if (img.url) {
                        totalImages++;
                    } else {
                        pendingImages++;
                    }
                });
            }
        });

        return {
            totalStores,
            uniqueStoresVisited,
            totalVisits,
            availableCount,
            notAvailableCount,
            complianceRate,
            totalImages,
            pendingImages,
            availableVisitsCount
        };
    }

    /** Everything the detail view renders, derived from state (channel-filtered). */
    getViewModel() {
        const { contract } = this.state;
        const { filteredContract, filteredChecks } = this.getFilteredData();
        return {
            filteredContract,
            filteredChecks,
            analytics: this.calculateAnalytics({ contract: filteredContract, contractChecks: filteredChecks }),
            contractType: getContractType(contract?.type),
            isExpired: Boolean(contract?.expirationDate && dayjs(contract.expirationDate).isBefore(dayjs(), 'day')),
            isClientUser: User.getInstance()?.userType === 'client',
            totalInvestment: getTotalInvestment(filteredContract),
            channelCounts: countStoresByChannel(contract?.stores)
        };
    }
}

export default ContractController;
